import * as React from "react";
import injectSheet from "react-jss";
import classNames from "classnames";

interface Props {
  classes: any;
  theme?: any;
}

const styleSheet = (theme: any) => ({
  formGroup: {
    alignItems: "flex-end",
    fontFamily: "CircularStd, sans-serif",
    margin: "0 auto",
    width: "100%",
    display: "flex",
    flexFlow: "row",
    marginTop: "20px",
    position: "relative",
    justifyContent: "center",
    flexWrap: "wrap",
    "@media (max-width: 900px)": {
      "& > div": {
        flex: "0 0 100% !important",
        padding: "0 !important"
      }
    }
  },
  children: {
    // "& > *:last-child": {
    //   marginLeft: 0,
    //   marginRight: 0
    // },
    // "& > *": {
    //   marginRight: "15px"
    // }
  }
});

const formGroup: React.FC<Props> = props => {
  const childrenCount = React.Children.toArray(props.children).length;

  var groupClasses = classNames(props.classes.formGroup, {
    [props.classes.children]: childrenCount > 1
  });

  return <div className={groupClasses}>{props.children}</div>;
};

export default injectSheet(styleSheet)(formGroup);
